import React from "react"
import { Divider, Form, Grid, Header, Input } from "semantic-ui-react"
import { save } from "../store/reducers/SrciInputData"
import { useAppSelector, useAppDispatch } from "../store/hooks"
import { RootState } from "../store/SrciStore"

export default function DeliveryPage() {
  const billingAddress = useAppSelector((state: RootState) => state.srciInputData.billingAddress)
  const consumer = useAppSelector((state: RootState) => state.srciInputData.dcfCheckoutParams.consumer)
  const dcfCheckoutParams = useAppSelector((state: RootState) => state.srciInputData.dcfCheckoutParams)
  const dispatch = useAppDispatch()

  const handleEmailChange = async (e: any, element: any) => {
    if (dcfCheckoutParams.consumer.consumerIdentity.identityType === "EMAIL_ADDRESS") {
      dispatch(
        save({
          name: "dcfCheckoutParams.consumer.consumerIdentity.identityValue",
          value: element.value,
        })
      )
    }

    dispatch(
      save({
        name: "dcfCheckoutParams.consumer.emailAddress",
        value: element.value,
      })
    )
  }

  const handlePhoneChange = (e: any, element: any) => {
    if (dcfCheckoutParams.consumer.consumerIdentity.identityType === "MOBILE_PHONE_NUMBER") {
      dispatch(
        save({
          name: "dcfCheckoutParams.consumer.consumerIdentity.identityValue",
          value: dcfCheckoutParams.consumer.mobileNumber.countryCode + "" + element.value,
        })
      )
    }

    dispatch(
      save({
        name: "dcfCheckoutParams.consumer.mobileNumber.phoneNumber",
        value: element.value,
      })
    )
  }

  const handleOnChange = (e: any, element: any) => {
    dispatch(
      save({
        name: element.name,
        value: element.value,
      })
    )
  }

  const countryCodes = [
    { key: undefined, text: "undefined", value: undefined },
    { key: "GB", text: "GB", value: "GB" },
    { key: "SE", text: "SE", value: "SE" },
  ]

  const consumerCountries = countryCodes.concat({ key: "PL", text: "PL", value: "PL" })

  return (
    <React.Fragment>
      <Form>
        <Grid columns={2}>
          <Grid.Column>
            <Header as="h2">Personal data</Header>
            <Form.Field>
              <label>Email Address</label>
              <Input
                value={consumer.emailAddress}
                name="dcfCheckoutParams.consumer.emailAddress"
                onChange={handleEmailChange}
              />
            </Form.Field>
            <Form.Field>
              <label>First Name</label>
              <Input value={consumer.firstName} name="dcfCheckoutParams.consumer.firstName" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>Last Name</label>
              <Input value={consumer.lastName} name="dcfCheckoutParams.consumer.lastName" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>Phone Calling Code</label>
              <Input
                value={consumer.mobileNumber.countryCode}
                name="dcfCheckoutParams.consumer.mobileNumber.countryCode"
                onChange={handleOnChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Phone Number</label>
              <Input
                value={consumer.mobileNumber.phoneNumber}
                name="dcfCheckoutParams.consumer.mobileNumber.phoneNumber"
                onChange={handlePhoneChange}
              />
            </Form.Field>
            <Form.Select
              fluid
              label="Consumer Country"
              options={consumerCountries}
              value={consumer.countryCode}
              name="dcfCheckoutParams.consumer.countryCode"
              onChange={handleOnChange}
            />
          </Grid.Column>
          <Grid.Column>
            <Header as="h2">Address</Header>

            <Form.Field>
              <label>Name</label>
              <Input value={billingAddress.name} name="billingAddress.name" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>Line 1</label>
              <Input value={billingAddress.line1} name="billingAddress.line1" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>Line 2</label>
              <Input value={billingAddress.line2} name="billingAddress.line2" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>Line 3</label>
              <Input value={billingAddress.line3} name="billingAddress.line3" onChange={handleOnChange} />
            </Form.Field>

            <Form.Field>
              <label>City</label>
              <Input value={billingAddress.city} name="billingAddress.city" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>State</label>
              <Input value={billingAddress.state} name="billingAddress.state" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>Zip</label>
              <Input value={billingAddress.zip} name="billingAddress.zip" onChange={handleOnChange} />
            </Form.Field>
            <Form.Select
              fluid
              label="Country Code"
              options={countryCodes}
              defaultValue={billingAddress.countryCode}
              name="billingAddress.countryCode"
              onChange={handleOnChange}
            />
          </Grid.Column>
        </Grid>
      </Form>

      <Divider hidden />
    </React.Fragment>
  )
}
